import Model from "../../Model.js";

/**
 * An account operation specifies which transactions are summed for a given fiscal year period
 * (e.g. opening balance, closing balance, year to date, change).
 *
 * @abstract
 */
export default class AbstractAccountOperation extends Model {
	getName() {
		this._subclassResponsibility();
	}

	getShortName() {
		this._subclassResponsibility();
	}

	getOperationType() {
		return this.constructor.getOperationType();
	}

	equals(other) {
		return this.constructor === other.constructor;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();
		properties.type = this.constructor.getType();
		return properties;
	}

	static getType() {
		this._subclassResponsibility();
	}

	static getOperationType() {
		this._subclassResponsibility();
	}
}
